const booleanAttributes = new Set([
    'allowfullscreen',
    'async',
    'autofocus',
    'autoplay',
    'checked',
    'controls',
    'default',
    'defer',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'formnovalidate',
    'hidden',
    'itemscope',
    'loop',
    'multiple',
    'muted',
    'nomodule',
    'novalidate',
    'open',
    'playsinline',
    'readonly',
    'required',
    'reversed',
    'scoped',
    'seamless',
    'selected'
]);
export default booleanAttributes;
//# sourceMappingURL=booleanAttributes.js.map